module.exports = __webpack_public_path__ + "static/mariana-b-604752-unsplash-7db39af3f902b9f4f518d72d840f1139.jpg";